// Define the ColorCode type
export enum ColorCode {
  lavender = 'lavender',
  grape = 'grape',
  flamingo = 'flamingo',
  banana = 'banana',
  sage = 'sage',
  basil = 'basil',
  peacock = 'peacock',
  blueberry = 'blueberry',
  tomato = 'tomato',
  tangerine = 'tangerine',
  graphite = 'graphite',
}

// Define the colors array with shades
export const colors: {
  code: ColorCode;
  label: string;
}[] = [
  {
    code: ColorCode.lavender,
    label: 'Lavender',
  },
  {
    code: ColorCode.flamingo,
    label: 'Flamingo',
  },
  {
    code: ColorCode.banana,
    label: 'Banana',
  },
  {
    code: ColorCode.sage,
    label: 'Sage',
  },
  {
    code: ColorCode.peacock,
    label: 'Peacock',
  },
  {
    code: ColorCode.blueberry,
    label: 'Blueberry',
  },
  {
    code: ColorCode.tomato,
    label: 'Tomato',
  },
  {
    code: ColorCode.tangerine,
    label: 'Tangerine',
  },
  {
    code: ColorCode.graphite,
    label: 'Graphite',
  },
];

// Function to get color by code and shade
export const getColor = (
  code: ColorCode,
  shade: number,
  def: ColorCode = ColorCode.blueberry,
) => {
  let color = colors.find((color) => color.code === code);
  if (!color) {
    return `var(--color-${def}-${shade})`;
  }
  return `var(--color-${color?.code}-${shade})`;
};

export const colorOptions = colors.map((c) => ({
  label: c.label,
  value: c.code,
  icon: `pi pi-circle-fill`,
  iconColor: getColor(c.code, 500),
}));
